import { HttpErrorResponse } from '@angular/common/http';

export class UpdateOfficerDetailsPermissionsActionResult {
  constructor(public actionType: ActionType, public httpErrorResponse: HttpErrorResponse | string, public isSuccess: boolean) {}
}

export enum ActionType {
  UpdateAgencyOfficerDetails = 'UpdateAgencyOfficerDetails',
  UpdateAgencyOfficerPermissions = 'UpdateAgencyOfficerPermissions',
}
